import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  IconButton,
  Collapse,
} from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

import OrdersIcon from "assets/icons/userIcon.svg";
import RequestsIcon from "assets/icons/doubleArrows.svg";
import DashboardIcon from "assets/icons/Clipboard.svg";
import packageIcon from "assets/icons/packageIcon.svg";
import { useRTL } from "hooks/isRTL";
import customermanagement from "assets/icons/customermanagement.svg";
import notfication from "assets/icons/notification.svg";
import DriverManagmenticon from "assets/icons/DriverManagmenticon.svg";
import { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { useTranslation } from "react-i18next";

const SidebarLinks = ({ isExpanded }) => {
  const location = useLocation();
  const [isDriverSubmenuOpen, setIsDriverSubmenuOpen] = useState(false);
  const [isOrdersSubmenuOpen, setIsOrdersSubmenuOpen] = useState(false);
  const [isWalletsSubmenuOpen, setIsWalletsSubmenuOpen] = useState(false);
  const [isDeliveryPricingSubmenuOpen, setIsDeliveryPricingSubmenuOpen] = useState(false);
  const { i18n } = useTranslation();

  const { t } = useRTL();

  const links = [
    { icon: DashboardIcon, label: t("DASHBOARD"), path: "/dashboard" },
    { icon: OrdersIcon, label: t("ORDERS"), path: "/orders", hasSubmenu: true },
    {
      icon: RequestsIcon,
      label: t("DRIVERS_REQUESTS"),
      path: "/driversRequests",
    },
    {
      icon: customermanagement,
      label: t("customerManagement"),
      path: "/customerManagement",
    },
    {
      icon: DriverManagmenticon,
      label: t("driverManagement"),
      path: "/driverManagement",
      hasSubmenu: true,
    },
    {
      icon: notfication,
      label: t("pushNotifiaction"),
      path: "/pushNotification",
    },
    {
      icon: packageIcon,
      label: "Delivery Pricing Options",
      path: "/delivery-pricing/expedited",
      hasSubmenu: true,
    },
    {
      icon: notfication,
      label: t("Wallets Management"),
      path: "/wallets-management",
      hasSubmenu: true,
    },
  ];

  return (
    <Box
      sx={{
        marginTop: "1rem",
        flex: 1,
        paddingLeft: "8px",
        paddingRight: "8px",
      }}
    >
      <List>
        {links.map((link, index) => {
          const isDriverManagement = link.path === "/driverManagement";
          const isOrders = link.path === "/orders";
          const isWallets = link.path === "/wallets-management";
          const isDeliveryPricing = link.path.startsWith("/delivery-pricing");
          const isActive =
            location.pathname === link.path ||
            (isDriverManagement &&
              location.pathname === "/driverManagement/locations") ||
            (isOrders && location.pathname === "/orders/expedited") ||
            (isWallets && (location.pathname.startsWith("/wallet") || location.pathname.startsWith("/cash-out"))) ||
            (isDeliveryPricing && location.pathname.startsWith("/delivery-pricing"));

          return (
            <Box key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: isActive
                    ? "rgba(255, 255, 255, 0.1)"
                    : "inherit",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                <ListItem
                  component={isWallets || isDeliveryPricing ? "div" : RouterLink}
                  {...(isWallets
                    ? {
                        button: true,
                        onClick: (e) => {
                          e.stopPropagation();
                          setIsWalletsSubmenuOpen((p) => !p);
                        },
                      }
                    : isDeliveryPricing
                    ? {
                        button: true,
                        onClick: (e) => {
                          e.stopPropagation();
                          setIsDeliveryPricingSubmenuOpen((p) => !p);
                        },
                      }
                    : { to: link.path })}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isExpanded ? "flex-start" : "center",
                    padding: "0.75rem 1rem",
                    gap: "0.5rem",
                    flexGrow: 1,
                  }}
                >
                  <ListItemIcon
                    sx={{ justifyContent: "center", minWidth: "40px" }}
                  >
                    <img
                      src={link.icon}
                      alt={link.label}
                      style={{
                        width: "24px",
                        height: "24px",
                        filter: "brightness(0) invert(1)",
                      }}
                    />
                  </ListItemIcon>

                  {isExpanded && (
                    <ListItemText
                      primary={link.label}
                      sx={{
                        color: "#fff",
                        fontSize: "1rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginLeft: "0",
                        textAlign: "start",
                      }}
                    />
                  )}
                </ListItem>

                {isExpanded && isDriverManagement && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsDriverSubmenuOpen((prev) => !prev);
                    }}
                    sx={{
                      color: "#fff",
                      marginRight: "0.5rem",
                    }}
                  >
                    {isDriverSubmenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                )}

                {isExpanded && isOrders && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOrdersSubmenuOpen((prev) => !prev);
                    }}
                    sx={{
                      color: "#fff",
                      marginRight: "0.5rem",
                    }}
                  >
                    {isOrdersSubmenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                )}
                {isExpanded && isDeliveryPricing && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsDeliveryPricingSubmenuOpen((prev) => !prev);
                    }}
                    sx={{
                      color: "#fff",
                      marginRight: "0.5rem",
                    }}
                  >
                    {isDeliveryPricingSubmenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                )}
                {isExpanded && isWallets && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsWalletsSubmenuOpen((prev) => !prev);
                    }}
                    sx={{
                      color: "#fff",
                      marginRight: "0.5rem",
                    }}
                  >
                    {isWalletsSubmenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                )}
              </Box>

              {isDriverSubmenuOpen && isDriverManagement && (
                <Collapse in={isDriverSubmenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      component={RouterLink}
                      to="/driverManagement/locations"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded
                          ? 6
                          : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          justifyContent: "center",
                          minWidth: "40px",
                        }}
                      >
                        <GroupRemoveIcon
                          sx={{ color: "#fff", fontSize: "20px" }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary={t("activeDrivers")}
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
              )}

              {isOrdersSubmenuOpen && isOrders && (
                <Collapse in={isOrdersSubmenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      component={RouterLink}
                      to="/orders/expedited"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded
                          ? 6
                          : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          justifyContent: "center",
                          minWidth: "40px",
                        }}
                      >
                        <LocalShippingIcon
                          sx={{ color: "#fff", fontSize: "20px" }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary="Active Expedited"
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
              )}

              {isDeliveryPricingSubmenuOpen && isDeliveryPricing && (
                <Collapse in={isDeliveryPricingSubmenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      component={RouterLink}
                      to="/delivery-pricing/expedited"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <LocalShippingIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="Expedited Pricing Options"
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      component={RouterLink}
                      to="/delivery-pricing/regular"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <LocalShippingIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="Regular Pricing Options"
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
              )}

              {isWalletsSubmenuOpen && isWallets && (
                <Collapse in={isWalletsSubmenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      component={RouterLink}
                      to="/wallet-transactions"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <MonetizationOnIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>

                      <ListItemText
                        primary={t("Wallet Transactions")}
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      component={RouterLink}
                      to="/wallets"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <AccountBalanceWalletIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>

                      <ListItemText
                        primary={t("Drivers Wallets")}
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      component={RouterLink}
                      to="/cash-out-requests"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <RequestPageIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>

                      <ListItemText
                        primary={t("Cash Out Requests")}
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      component={RouterLink}
                      to="/cash-out-rule"
                      sx={{
                        [i18n.language === "ar" ? "pr" : "pl"]: isExpanded ? 6 : 2,
                        padding: isExpanded ? "0.5rem 2rem" : "0.5rem 1rem",
                        color: "#fff",

                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ justifyContent: "center", minWidth: "40px" }}>
                        <AccountBalanceWalletIcon sx={{ color: "#fff", fontSize: "20px" }} />
                      </ListItemIcon>

                      <ListItemText
                        primary={t("Cash Out Rule")}
                        sx={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textAlign: i18n.language === "ar" ? "right" : "start",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
              )}
            </Box>
          );
        })}
      </List>
    </Box>
  );
};

export default SidebarLinks;
